import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TranslatorModule } from 'angular-translator';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedModule } from '../../helpers/shared.module';
import { RuleEditorComponent } from './reglas.editor.component';
import { ReglasHistorialComponent } from './reglas.historial.component';
import { AceEditorModule } from 'ng2-ace-editor';
import { MomentModule } from 'angular2-moment';
import { DiffMatchPatchModule } from 'ng-diff-match-patch';

@NgModule({
  declarations: [
    RuleEditorComponent,
    ReglasHistorialComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    SharedModule,
    TranslatorModule,
    NgbModule,
    RouterModule,
    AceEditorModule,
    MomentModule,
    DiffMatchPatchModule
  ],
  exports: [
    RuleEditorComponent,
    ReglasHistorialComponent
  ]
})
export class RulesModule { }


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/reglas/rules.module.ts